





































import { mapGetters } from 'vuex';
import Onboarding from './Onboarding.vue';
import dataSettingApis from '@/apis/data-setting.apis';
import commonUtils from '@/common/utils/common.utils';
import SettingsTable from './table.vue';
import docsUrl from '@common/configs/docsUrl';
import { checkModuleRole, RoleModuleKey } from '@/common/services/singleSpa.service';

export default {
    name: 'EventPropertySettings',

    data() {
        const moreOptions = [
            // {
            //     name: 'View Events',
            //     code: 'viewEvents'
            // },
            {
                name: this.$t('common.button_edit'),
                code: 'edit',
                roleKey: 'ptxEventPropertyUpdate'
            }
        ].filter(item => checkModuleRole(item.roleKey as RoleModuleKey));
        const tableHeader = [
            {
                code: 'name',
                sortCode: 'showName',
                name: this.$t('data_settings.list_name'),
                dataType: 'string',
                supportSortable: true,
                span: 8
            },
            {
                code: 'source',
                sortCode: 'showSource',
                name: this.$t('data_settings.list_source'),
                dataType: 'string',
                supportSortable: true,
                span: 4
            },
            {
                code: 'type',
                sortCode: 'showType',
                name: this.$t('data_settings.list_type'),
                tips: this.$t('annotation.data_3'),
                canEdit: true,
                dataType: 'string',
                supportSortable: true,
                span: 4
            },
            {
                code: 'description',
                sortCode: 'showDescription',
                name: this.$t('common.description'),
                tips: this.$t('annotation.data_4'),
                canEdit: true,
                dataType: 'string',
                supportSortable: true,
                span: 8
            }
        ];
        const typeOptions = [
            {
                code: 'STRING',
                name: this.$t('data_settings.data_type_string')
            },
            {
                code: 'TIME',
                name: this.$t('data_settings.data_type_date')
            },
            {
                code: 'NUMBER',
                name: this.$t('data_settings.data_type_number')
            }
        ];
        const sourceOptions = [
            {
                code: 'code',
                name: this.$t('data_settings.data_source_code')
            },
            {
                code: 'experience',
                name: this.$t('data_settings.data_experience')
            },
            {
                code: 'setting',
                name: this.$t('data_settings.data_source_setting')
            }
        ];
        return {
            moreOptions,
            tableHeader,
            typeOptions,
            sourceOptions,
            tableBody: [],
            joinString: '_tmp', //备份字段连接字符串
            loading: true,
            docUrl: docsUrl.eventSetting
        };
    },

    computed: {
        ...mapGetters('main', ['profileInfo', 'userInfo']),

        canEditList() {
            return this.tableHeader.filter(item => item.canEdit);
        },

        currentRouteIsMe() {
            return this.$route.name === 'EventPropertySettings';
        },

        iconName() {
            return this.userInfo.area.toLocaleUpperCase() === 'EN'
                ? 'icon-event-property-en'
                : this.userInfo.area.toLocaleUpperCase() === 'ZH'
                ? 'icon-event-property-cn'
                : 'icon-event-property';
        }
    },

    created() {
        this.fetchEventsProperties();
    },

    methods: {
        async fetchEventsProperties() {
            const [err, res] = await commonUtils.awaitWrap(
                dataSettingApis.getEventProperties(null, {
                    where: {
                        sid: this.profileInfo.sid
                    }
                })
            );
            if (err) {
                this.currentRouteIsMe && console.log('get event properties failed.');
            } else {
                this.tableBody = res.map(event => {
                    const { type, description } = event;
                    event.rowEditing = false;
                    Object.keys(event).forEach(key => {
                        const eventInfo = this.tableHeader.find(item => item.code === key);
                        if (eventInfo) {
                            event[eventInfo.sortCode] = this.getCellVal(key, event[key]);
                        }
                    });

                    // 备份可编辑项数据
                    Object.keys(event).forEach(key => {
                        const canEdit = this.canEditList.some(item => item.code === key);
                        canEdit && (event[`${key}${this.joinString}`] = event[key]);
                    });
                    return event;
                });
            }
            this.loading = false;
        },

        async handleRowChange({ id, name, displayName, source, type, description }) {
            const [err, res] = await commonUtils.awaitWrap(
                dataSettingApis.updateEventProperty(null, {
                    data: {
                        name,
                        displayName,
                        source,
                        type,
                        description
                    },
                    where: {
                        name,
                        sid: this.profileInfo.sid
                    }
                })
            );
            err && this.currentRouteIsMe && cthis.$message.error(this.$t('error.update_event_property'));
        },

        getCellVal(code, value) {
            if (code === 'type') {
                const info = this.typeOptions.find(item => item.code === value.toLocaleUpperCase());
                return (info && info.name) || value;
            } else if (code === 'source') {
                return (value || [])
                    .map(i => {
                        var sourceInfo = this.sourceOptions.find(item => item.code === i);
                        return (sourceInfo && sourceInfo.name) || i;
                    })
                    .join();
            }
            return value;
        }
    },
    components: {
        Onboarding,
        SettingsTable
    }
};
